import { render } from "./JourneySearch.vue?vue&type=template&id=4620951b&lang=pug"
import script from "./JourneySearch.vue?vue&type=script&lang=ts"
export * from "./JourneySearch.vue?vue&type=script&lang=ts"

import "./JourneySearch.vue?vue&type=style&index=0&id=4620951b&lang=scss"
script.render = render

export default script